export default __webpack_public_path__ + "static/media/mandatet.2f6212b3.jpg";